import FieldDefs from './AdKeysByAdsFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import AdKeysByAdsGny from "./AdKeysByAdsGny";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.adkeysbyads", isGoogleGny() ? AdKeysByAdsGny : FieldDefs),
            sortOrder: [
                {
                    field: window.report_db.engine === "yandex" ? 'wsk' : 'ws',
                    direction: 'desc'
                },
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
